// Components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Assets
import {
  faAddressCard,
  faCartShopping,
  faChartColumn,
  faCheck,
  faClockRotateLeft,
  faFileInvoiceDollar,
  faKey,
  faListUl,
} from '@fortawesome/free-solid-svg-icons'

// Utilities
import pages from './pages'
import { CgProfile } from 'react-icons/cg'

export const cards = [
  {
    icon: <FontAwesomeIcon icon={faCheck} className="w-12 h-12 text-primary" />,
    name: 'Rezolvă grile',
    to: pages.app.grid,
    description:
      'Rezolvă grile, una câte una, pe baza sistemului nostru de A.I. care te va ajuta să îți maximizezi progresul.',
    backgroundColor: 'rgb(var(--container-background))',
  },
  {
    icon: (
      <FontAwesomeIcon icon={faListUl} className="w-12 h-12 text-primary" />
    ),
    name: 'Simulare',
    to: pages.app.subject,
    description:
      'Poți simula, exact ca la exame, un subiect întreg, fie dat în anii trecuți, fie compus de noi.',
    backgroundColor: 'rgb(var(--container-background))',
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faChartColumn}
        className="w-12 h-12 text-primary"
      />
    ),
    name: 'Statistici',
    to: pages.app.dashboard,
    description:
      'Poți urmări îndeaproape progresul tău și poți vedea la ce capitole trebuie să te îmbunătățești..',
    backgroundColor: 'rgb(var(--container-background))',
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faClockRotateLeft}
        className="w-12 h-12 text-primary"
      />
    ),
    name: 'Istoric',
    to: pages.app.history,
    description:
      'Vezi grilele și simulările rezolvate, treci din nou prin ele și întelege mai bine ce ai gresit.',
    backgroundColor: 'rgb(var(--container-background))',
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faCartShopping}
        className="w-12 h-12 text-primary"
      />
    ),
    name: 'Abonamente',
    to: pages.app.payment,
    description:
      'Vezi variantele de abonamente și alege-l pe cel care te avantajează.',
    backgroundColor: 'rgb(var(--container-background))',
  },

  {
    icon: <CgProfile className="w-12 h-12 text-primary" />,
    name: 'Profil',
    to: pages.app.profile,
    description: 'Vezi profilul tău, setările, facturile și altele.',
    backgroundColor: 'rgb(var(--container-background))',
  },
]
